import { Loader } from '../Widgets';
import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { AppSettings, BusinessSummaryModel, Employee, Transaction } from 'service';
import ArthaGateway from 'service/ServerGateway';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCableCar, faCalendar, faCalendarCheck, faFileInvoiceDollar, faIdBadge, faPhone, faPlane, faUser } from '@fortawesome/free-solid-svg-icons';
import attendance from '../../assets/images/attendance.png'
import payslip from '../../assets/images/payslip.png'
import profile from '../../assets/images/profile.png'
import leaves from '../../assets/images/leave.png'
import SettingsService from 'service/SettingsService';

export const Dashboard = () => {
    const user = useSelector((state: RootState) => state.appdata);
    const [employee, setemployee] = useState<Employee>();
    const [settings, setSettings] = useState<AppSettings>();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const navigate = useNavigate();
    useEffect(() => {
        if (user.profile) {
            setemployee(user.profile.profile);
            setIsLoading(false);

            // Get the server app settings
            SettingsService.get()
                .then((data) => {
                    setSettings(data);
                });
        }
    }, [user]);

    return (
        <>
            <div className="page-dashboard">
                <div className="container">
                    <div className='row'>
                        <div className='page-header card bg-success text-white pb-2'>
                            Welcome,
                            <h2>{employee?.name}</h2>
                            <p>{employee?.employeeNumber}</p>
                        </div>
                    </div>
                    {isLoading &&
                        <Loader />
                    }
                    {!isLoading &&
                        <div className='row'>
                            {settings?.showAttendance &&
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/attendance">
                                       <div className="card bg-success">
                                            <div className="card-img-top d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                                                <FontAwesomeIcon icon={faCalendarCheck} style={{ fontSize: '4rem' }} className="text-white" />
                                            </div>
                                            <div className="card-body">
                                                <h5 className="card-title text-white">Attendance</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            }

                            {settings?.showLeaves &&
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/leave">
                                        <div className="card bg-success">
                                            <div className="card-img-top d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                                                <FontAwesomeIcon icon={faPlane} style={{ fontSize: '4rem' }} className="text-white" />
                                            </div>
                                            <div className="card-body">
                                                <h5 className="card-title text-white">Leaves</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            }

                            {settings?.showPayslips &&
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/payslip">
                                        <div className="card bg-success">
                                            <div className="card-img-top d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                                                <FontAwesomeIcon icon={faFileInvoiceDollar} style={{ fontSize: '4rem' }} className="text-white" />
                                            </div>
                                            <div className="card-body">
                                                <h5 className="card-title text-white">Payslips</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            }

                            <div className="col-lg-3 col-md-6 col-6 mb-4">
                                <NavLink to="/profile">
                                    <div className="card bg-success">
                                            <div className="card-img-top d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                                                <FontAwesomeIcon icon={faUser} style={{ fontSize: '4rem' }} className="text-white" />
                                            </div>
                                            <div className="card-body">
                                                <h5 className="card-title text-white">My Profile</h5>
                                            </div>
                                        </div>
                                </NavLink>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </>
    );
};